import React from "react";
import { motion } from "framer-motion";
import { Eye, Users, Sparkles } from "lucide-react";

const PILLARS = [
  {
    icon: Eye,
    title: "A Phenomenon",
    body:
      "When a critical number wake up to an idea, awareness leaps from mind to mind. The hundredth monkey is the tipping monkey.",
  },
  {
    icon: Users,
    title: "A Movement",
    body:
      "Keyes wrote the book as activism. The text begs to be copied and passed on — long before the internet made copying easy.",
  },
  {
    icon: Sparkles,
    title: "A Practice",
    body:
      "The work is interior, then exterior. Cultivate love and clarity; let the field strengthen each time another monkey tunes in.",
  },
];

const CARD_REVEAL = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.3 },
};

// Pre-computed per-card transitions — static data, no per-render object creation.
const CARD_TRANSITIONS = PILLARS.map((_, i) => ({
  delay: i * 0.08,
  duration: 0.55,
}));

export default function PillarsSection() {
  return (
    <section className="border-b-2 border-current" data-testid="pillars-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-20 grid gap-10 md:grid-cols-3">
        {PILLARS.map(({ icon: Icon, title, body }, i) => (
          <motion.div
            key={title}
            {...CARD_REVEAL}
            transition={CARD_TRANSITIONS[i]}
            className="border-2 border-current p-7 bg-[hsl(var(--background))]"
            data-testid={`pillar-card-${i}`}
          >
            <Icon size={28} className="mb-4" />
            <h3 className="font-display uppercase font-bold text-2xl mb-3 tracking-tight">
              {title}
            </h3>
            <p className="font-body text-lg leading-relaxed opacity-90">{body}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
